"use client";
import { useRef } from "react";
import { motion } from "motion/react";
import Centerpiece from "../General Components/Centerpiece";
import SpringButton from "../General Components/SpringButton";
import GameCard, { GameRow } from "../Games/GameCard";

const GamesPageComp = ({ games }: { games: GameRow[] }) => {
  const cardRefs = useRef<(HTMLDivElement | null)[]>([]);

  const scrollToRandom = () => {
    if (games.length === 0) return;
    const index = Math.floor(Math.random() * games.length);
    cardRefs.current[index]?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  const HeroContent = () => (
    <div className="flex flex-col items-center justify-center h-full text-center px-4 py-12">
      <motion.h1
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-7xl font-bold"
        style={{
          textShadow:
            "var(--text-glow-color) 0px 0px 10px, var(--background) 0px 0px 8px",
        }}
      >
        Games
      </motion.h1>

      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 0.7, delay: 0.4 }}
        className="bg-(--uforeground2) h-0.75 w-full max-w-120 my-5"
        style={{ transformOrigin: "center" }}
      />

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.6 }}
        className="text-xl text-(--foreground2) mb-8 max-w-140"
      >
        Games I&apos;ve designed and built
      </motion.p>

      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4, delay: 0.8, type: "spring", stiffness: 200 }}
      >
        <SpringButton onClick={scrollToRandom}>
          Random Game →
        </SpringButton>
      </motion.div>
    </div>
  );

  return (
    <div>
      <Centerpiece>{HeroContent()}</Centerpiece>

      <div className="mx-[4%] flex flex-col gap-8 mb-16">
        {games.map((game, index) => (
          <div
            key={game.id}
            id={`game-${game.id}`}
            ref={(el) => { cardRefs.current[index] = el; }}
            style={{ scrollMarginTop: "90px" }}
          >
            <GameCard game={game} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default GamesPageComp;
